<template>
    <div class="flex flex-col gap-12 w-full grow-1 items-center justify-center">

        <y-container large class="!px-16 !pb-8 !pt-6 !bg-background lg:!w-84">
            <form class="flex flex-col gap-4 items-center" @submit.prevent="login_user">
                <page-title class="!mb-6">Log in</page-title>
                <div class="flex flex-col gap-4 md:!w-56 items-center">
                    <input-field class="w-full" label="Email" placeholder="Email" v-model="credentials.email"/>
                    <input-field
                        class="w-full"
                        label="Password"
                        placeholder="Password"
                        type="password"
                        v-model="credentials.password"
                        :error="user_login_error"
                    />
                </div>
                <y-button class="!w-auto">Log in</y-button>
            </form>
        </y-container>

        <a
            href="/api/auth/slack/login"
            style="align-items:center;color:#fff;background-color:#4A154B;border:0;border-radius:48px;display:inline-flex;font-family:Lato, sans-serif;font-size:16px;font-weight:600;height:48px;justify-content:center;text-decoration:none;width:236px"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                style="height:20px;width:20px;margin-right:12px"
                viewBox="0 0 122.8 122.8"
            >
                <path
                    d="M25.8 77.6c0 7.1-5.8 12.9-12.9 12.9S0 84.7 0 77.6s5.8-12.9 12.9-12.9h12.9v12.9zm6.5 0c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v32.3c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V77.6z"
                    fill="#e01e5a"
                ></path>
                <path
                    d="M45.2 25.8c-7.1 0-12.9-5.8-12.9-12.9S38.1 0 45.2 0s12.9 5.8 12.9 12.9v12.9H45.2zm0 6.5c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H12.9C5.8 58.1 0 52.3 0 45.2s5.8-12.9 12.9-12.9h32.3z"
                    fill="#36c5f0"
                ></path>
                <path
                    d="M97 45.2c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9-5.8 12.9-12.9 12.9H97V45.2zm-6.5 0c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V12.9C64.7 5.8 70.5 0 77.6 0s12.9 5.8 12.9 12.9v32.3z"
                    fill="#2eb67d"
                ></path>
                <path
                    d="M77.6 97c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9-12.9-5.8-12.9-12.9V97h12.9zm0-6.5c-7.1 0-12.9-5.8-12.9-12.9s5.8-12.9 12.9-12.9h32.3c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H77.6z"
                    fill="#ecb22e"
                ></path>
            </svg>
            Login with Slack
        </a>
    </div>
</template>

<script lang="ts" setup>
// import { useAuthUser } from '#layers/cms/app/composables/useAuthUser';
// import { useUserStore } from '#layers/cms/app/store/user';
// import {Permissions} from '#layers/cms/server/models/user.model'
const { loggedIn, user, fetch: refreshSession } = useUserSession()

const userStore = useUserStore()

const user_login_error = ref()

const credentials = reactive({
    password: '',
    email: ''
})


if (process.server) {

} else {

}

const login_user = async () => {
    try {
        const user = await $fetch('/api/auth/user/log-in', {
            method: 'POST',
            body: credentials
        })
        console.log(user)
        if (!user.success) throw new Error(user?.message)
        await refreshSession()
        await useAuth().fetchSession()
        // await userStore.fetchUser()
        await navigateTo('/dashboard', { external: true })

    } catch (e: any) {
        console.log(e)
        if (e.statusMessage) user_login_error.value = e?.statusMessage
        else if (e.message) user_login_error.value = e?.message
        else if (e) user_login_error.value = e
    }
}
</script>
